<style lang="less" scoped>
.h5-about-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .flex-1 {
    flex: 1;
  }
  font-size: 12px;
}
.h5-content-div {
  margin: 16px;
  padding: 0 0 16px 0;
}
.topic-title {
  text-align: center;
  font-weight: 900;
  line-height: 32px;
}
.content-div {
  text-indent: 2em;
}
.line-topic-title {
  font-weight: 900;
  line-height: 30px;
  height: 30px;
}

.table-content-div {
  width: 100%;
  overflow-x: scroll;
}
.policy-table {
  width: 100%;
  border-collapse: collapse;
}
.policy-table tr {
  height: 32px;
  line-height: 32px;
}
.policy-table tr th {
  padding-left: 2px;
}
.policy-table tr td {
  padding-left: 2px;
}
.policy-a {
  text-decoration: underline;
  cursor: pointer;
  word-wrap: break-word;
  word-break: break-all;
}

.width-1 {
  width: 20% !important;
}
</style>

<template>
  <div class="h5-about-container">
    <div class="h5-content-div">
      <div class="topic-title">《挚达APP》注册服务协议</div>

      <div class="line-topic-title">
        一、 总则
      </div>
      <div class="content-div">
        1.1.
        您应当仔细阅读本协议条款并按照页面上的提示完成全部的注册程序。您在注册程序过程中选择“同意”选项即表示您自愿与“挚达APP”达成协议，同意完全接受本协议项下的全部条款，愿意承担相应的用户义务，并成为“挚达APP”用户。
      </div>
      <div class="content-div">
        1.2.
        为方便联系您以解决各项事宜，请您注册时使用本人有效手机号码作为账号，“挚达APP”会以手机短信形式为该账号分配一个密码。该账号及相应的密码由您负责保管；您应当对该账号进行的所有活动和事件承担法律责任。
      </div>
      <div class="line-topic-title">
        二、 注册信息和隐私保护
      </div>
      <div class="content-div">
        2.1.
        “挚达APP”账号（即“挚达APP”用户ID）的所有权归属于“挚达APP”，您完成注册申请手续后，可获得“挚达APP”账号的使用权。注册时您应提供即时、详尽及准确的个人资料，并有义务不断更新注册资料，以符合即时、详尽、准确的要求。所有原始键入的资料将认定为注册资料。因注册资料不真实而引起的问题，及该问题引发的后果，“挚达APP”不承担任何责任。
      </div>
      <div class="content-div">
        2.2.
        因系统服务将涉及在线支付，适用于您与商户间发生的包括但不限于服务纠纷、付款错误、退款等情况，为方便及时联系与您确认，
        “挚达APP”强烈要求您使用真实的手机号码进行账号注册。
      </div>
      <div class="content-div">
        2.3.
        “挚达APP”提示您请勿将账号、密码转让、出售或借予他人使用，若您授权他人使用账号，对被授权人在该账户下实施的所有行为您须承担全部责任。
      </div>
      <div class="content-div">
        2.4.
        “挚达APP”承诺不对外公开或向第三方提供单个用户的注册资料，以下情况除外：
      </div>
      <div class="content-div">（1）事先获得用户的明确授权;</div>
      <div class="content-div">
        （2）只有透露用户个人资料，才能提供其所要求的产品和服务;
      </div>
      <div class="content-div">（3）根据有关的法律法规要求;</div>
      <div class="content-div">（4）按照相关政府主管部门的要求;</div>
      <div class="content-div">（5）为维护“挚达APP”的合法权益;</div>
      <div class="content-div">（6）其余“挚达APP”有理由公开的情形。</div>
      <div class="content-div">
        2.5.
        您在注册“挚达APP”账号，使用“挚达APP”产品或服务，访问“挚达APP”网页，或参加促销和有奖游戏等类似情形时，“挚达APP”将会自动收集您的个人身份识别资料且不再另行通知您。这些资料将会用于：改进并优化为您提供的服务及网页内容。
      </div>

      <div class="line-topic-title">
        三、 使用规则
      </div>

      <div class="content-div">
        3.1.
        您在使用“挚达APP”服务时，必须遵守中华人民共和国相关法律法规的规定，不得利用本服务进行任何违法或不正当的活动，包括但不限于下列行为：
      </div>
      <div class="content-div">
        （1）上载、展示、张贴、传播或以其他方式传达含有下列内容之一的信息：
      </div>
      <div class="content-div">1）反对宪法所确定的基本原则的；</div>
      <div class="content-div">
        2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
      </div>
      <div class="content-div">3）损害国家荣誉和利益的；</div>
      <div class="content-div">4）煽动民族仇恨、民族歧视、破坏民族团结的；</div>
      <div class="content-div">5）破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
      <div class="content-div">6）散布谣言，扰乱社会秩序，破坏社会稳定的；</div>
      <div class="content-div">
        7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
      </div>
      <div class="content-div">8）侮辱或者诽谤他人，侵害他人合法权利的；</div>
      <div class="content-div">
        9）含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵或其它道德上令人反感的内容；
      </div>
      <div class="content-div">
        10）含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；
      </div>

      <div class="content-div">（2）不得为任何非法目的而使用网络服务系统；</div>
      <div class="content-div">（3）不得利用“挚达APP”服务从事以下活动：</div>
      <div class="content-div">
        1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的；
      </div>
      <div class="content-div">
        2）未经允许，对计算机信息网络功能进行删除、修改或者增加的；
      </div>
      <div class="content-div">
        3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或增加的；
      </div>
      <div class="content-div">4）故意制作、传播计算机病毒等破坏性程序的；</div>
      <div class="content-div">5）其他危害计算机信息网络安全的行为。</div>

      <div class="content-div">
        3.2.
        因您违反本协议或相关服务条款的规定，导致或产生的任何第三方主张的索赔、要求或损失，包括合理的律师费在内，您同意对“挚达APP”及其合作公司、关联公司作出赔偿，并使之免受损害。对此，“挚达APP”有权根据您的行为性质，采取包括但不限于删除发布的信息内容、限制使用、暂停使用许可、终止服务、注销
        “挚达APP”账号、追究法律责任等措施。对恶意注册“挚达APP”账号或利用“挚达APP”账号进行违法活动，扰乱、骚扰、欺骗其他用户以及其他违反本协议的行为，“挚达APP”有权注销其账号。同时，“挚达APP”将会协助相关部门开展调查活动。
      </div>
      <div class="content-div">
        3.3.
        您不得将“挚达APP”服务任何部分或基于“挚达APP”服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其他目的。
      </div>
      <div class="content-div">
        3.4.
        您须对自己在使用“挚达APP”服务过程中的行为承担法律责任。您承担法律责任的形式包含但不限于：直接对受到侵害者进行赔偿，以及在“挚达APP”因您的行为遭受行政处罚或导致侵权损害赔偿后，给予“挚达APP”等额的赔偿。
      </div>

      <div class="line-topic-title">
        四、 服务内容
      </div>

      <div class="content-div">
        4.1. “挚达APP”网络服务的具体内容由“挚达APP”根据实际情况提供。
      </div>
      <div class="content-div">
        4.2.
        除非本服务协议另有其他明示规定，“挚达APP”推出的新产品、新功能、新服务，均受到本服务协议之规范。
      </div>
      <div class="content-div">
        4.3.
        为使用本服务，您必须经有提供互联网接入服务法律资格的第三方以进入国际互联网，并自行支付相关服务费用。此外，您必须自行配备及负责与国际互联网连线所需之一切必要装备，包括但不限于计算机、数据机或其它存取装置。
      </div>
      <div class="content-div">
        4.4.
        鉴于网络服务的特殊性，您知悉且同意“挚达APP”无需事先通知，有权随时变更、中断或终止部分或全部网络服务（包括收费网络服务）。“挚达APP”对网络服务是否存在中断可能性，以及网络服务的及时性、安全性、准确性均不作保证。
      </div>
      <div class="content-div">
        4.5.
        “挚达APP”将定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，您知悉并同意因此类情况而造成的网络服务（包括收费网络服务）在合理时间内的中断，
        “挚达APP”无需为此承担任何责任，且“挚达APP”无需事先通知用户，有权为维修、保养、升级或其它目的而暂停任何服务。
      </div>
      <div class="content-div">
        4.6.
        本服务提供过程中及第三人可自由提供其它国际互联网之网站或资源链接。由于“挚达APP”无法控制这些网站及资源信息的发布，您已了解并同意，对此类网站或资源是否具有可利用性，“挚达APP”不作保证且不承担任何责任，对存在或源于此类网站或资源之任何内容、广告、产品或其它资料，“挚达APP”亦不作保证且不承担任何责任。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，“挚达APP”不承担任何责任。
      </div>
      <div class="content-div">
        4.7.
        您明确同意在使用“挚达APP”网络服务过程中产生的风险将完全由其自己承担。，确认由您独立作出下载或通过“挚达APP”服务取得信息资料的行为，并愿意承担可能发生的系统受损、资料丢失以及其他任何风险。
      </div>
      <div class="content-div">
        4.8.
        “挚达APP”有权于任何时间暂时或永久地修改或终止本服务（或其任何部分），而无论其通知与否，“挚达APP”对您或任何第三人均无需承担任何责任。
      </div>
      <div class="content-div">
        4.9.
        终止服务：您同意“挚达APP”有权基于其自身之考虑，因任何原因，包含但不限于您长时间未使用，或“挚达APP”认为您已经违反本服务协议的文字及精神，终止您的密码、账号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本服务协议规定而提供之服务，“挚达APP”无需进行事先通知即可中断或终止；您承认并同意，“挚达APP”可随时关闭或删除您的账号及您账号中所有相关信息及文件，及/或禁止您继续使用前述文件或本服务。此外，您同意出现本服务之使用被中断、终止或您的账号及相关信息和文件被关闭、删除的情形，“挚达APP”对您或任何第三人均不承担任何责任。
      </div>

      <div class="line-topic-title">
        五、 知识产权和其他合法权益（包括但不限于名誉权、商誉权）
      </div>

      <div class="content-div">5.1. 知识产权：</div>
      <div class="content-div">
        （1）“挚达APP”所包含的全部智力成果包括但不限于数据库、网站设计、文字和图表、软件、照片、录像、音乐、声音及其前述组合，软件编译、相关源代码和软件
        （包括小应用程序和脚本）
        的知识产权权利均归“挚达APP”所有。未经特殊书面授权您不得为任何目的复制、更改、拷贝、发送或使用前述任何材料或内容。
      </div>
      <div class="content-div">
        （2）“挚达APP”名称中包含的所有权利 （包括商誉和商标）
        均归“挚达APP”所有。
      </div>
      <div class="content-div">
        （3）您接受本协议即视为已知悉并自愿主动将在“挚达APP”系统平台及相关区域发表的任何形式的信息的著作权，包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他财产权利长期无偿独占许可给“挚达APP”使用，“挚达APP”有权利就任何主体对上述著作权的侵权行为单独提起诉讼并获得全部赔偿。本协议属于《中华人民共和国著作权法》第二十五条规定的书面协议，其效力及于您在“挚达APP”发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。您请勿在“挚达APP”系统平台及相关区域内发布您无权使用或需保留著作权的信息材料，对此“挚达APP”将不再进行通知，因此而产生的侵权责任或权利纠纷，将由您自己承担责任。
      </div>
      <div class="content-div">
        （4）您在使用“挚达APP”服务过程中不得非法使用或处分“挚达APP”或他人的知识产权权利。您不得将已发表于“挚达APP”的信息以任何形式发布或授权其它网站（及媒体）使用。
      </div>

      <div class="line-topic-title">
        六、 其他
      </div>

      <div class="content-div">
        6.1. 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。
      </div>
      <div class="content-div">
        6.2.
        如双方就本协议内容或其执行发生任何争议，双方应通过友好协商的方式进行解决；协商不成时，任何一方均可向“挚达APP”所在地有管辖权的人民法院提起诉讼。
      </div>
      <div class="content-div">
        6.3.
        “挚达APP”未行使或执行本服务协议所规定的任何权利或规定，不构成对前述权利之放弃。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    init() {},
  },
  mounted() {
    this.init()
  },
}
</script>
